import { FC, useMemo } from 'react';
import classNames from 'classnames';

import styles from './index.module.scss';

interface IProps {
  score: number | undefined;
}

// Hardcoded values for scores so far
// If we need to do it more flexible lets split it into a separate components
// 1st component will be for the render label itself with provided values and styling (or tokens for styling)
// 2nd component will be for the logic of score calculation and passing it to the first component

const AILabel: FC<IProps> = (props: IProps): JSX.Element | null => {
  const { score } = props;

  const isScoreValid = typeof score === 'number';

  const inverted = isScoreValid && score >= 0.9;

  const scoreClassName = useMemo(() => {
    if (!isScoreValid) {
      return '';
    }
    if (score >= 0.9) {
      return styles.label_best;
    }
    if (score >= 0.75) {
      return styles.label_strong;
    }
    if (score >= 0.6) {
      return styles.label_likely;
    }
    if (score >= 0.4) {
      return styles.label_possible;
    }
    return styles.label_unlikely;
  }, [score, isScoreValid]);

  if (!isScoreValid) {
    return null;
  }

  return (
    <div className={classNames([styles.label, scoreClassName])}>
      {!inverted && <img src="/images/img-magic.svg" alt="" className={styles.icon} />}
      {inverted && <img src="/images/img-magic-inverted.svg" alt="" className={styles.icon} />}
      <span>{score}</span>
    </div>
  );
};

export default AILabel;
